// extracted by mini-css-extract-plugin
module.exports = {"featured-image-wrapper":"ArticleListLayout_featured-image-wrapper__gSVMr","header-container":"ArticleListLayout_header-container__rWhlI"};